type StepsBarInput = {
  currentStep: number;
  totalSteps: number;
};

function StepsBar({ currentStep, totalSteps }: StepsBarInput) {
  const steps = Array.from(Array(totalSteps).keys());

  return (
    <div className="flex h-1 w-96 space-y-0 space-x-4 ">
      {steps.map((el, index) => (
        <div key={el} className={`rounded-2xl  ${currentStep + 1 > index ? "bg-secondary" : "bg-white"} h-full w-24`} />
      ))}
    </div>
  );
}

export default StepsBar;
